import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { RdsIconsModule, RdsAccordionModule, RdsDividerModule } from '@rds/angular-components';

@Component({
  selector: 'inexp-knowledge-faq',
  imports: [RdsAccordionModule, RdsIconsModule, RdsDividerModule],
  templateUrl: './knowledge-faq.component.html',
  styleUrl: './knowledge-faq.component.scss',
})
export class KnowledgeFaqComponent {
  _uid = input<string>();
  component = input<string>();
  knowledgeSection = input<string>();
  router = inject(Router);
  faq = input<any[]>();
  hasPublishedItems(): boolean {
    return this.faq()?.some(b => b.published === true) ?? false;
  }
}
